
// Main imports
import React from 'react';
import PageTitle from '../../components/PageTitle/PageTitle';
import moment from 'moment';
import Cookies from 'universal-cookie';
import { NineCellLoading } from 'react-loadingg';

// Local
import img from '../../images/background_image.png';
import getLezioni from '../../services/getLezioni';
import Utils from "../../utils/utils";
import getStudenti from '../../services/getStudenti';
import getInsegnanti from '../../services/getInsegnanti';
import getCorsi from '../../services/getCorsi';
import getFatture from '../../services/getFatture';
import getRataStatusAll from '../../services/getRataStatusAll';

// Firebase
import translateString from '../../utils/Locales';

let t = translateString;

export default class Dashboard extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: true,
            warningToShow: false,
            isSmallDevice: false,
        };
    }

    handleResize() {
        if (window.innerWidth <= 785) {
            this.setState({ isSmallDevice: true });
        } else {
            this.setState({ isSmallDevice: false });
        }
    }

    async componentDidMount() {

        window.addEventListener('resize', this.handleResize.bind(this))
        this.handleResize();
        //setUserProperties(analytics, { site_user_logged: true, main_user: false, user_registered_demo: true });
        
        const cookies = new Cookies();
        const username = cookies.get('username', { path: '/' });
        const token = cookies.get('token', { path: '/' });
        this.lezioni = await getLezioni(username, token);
        this.studenti = await getStudenti(username, token);
        this.insegnanti = await getInsegnanti(username, token);
        this.corsi = await getCorsi(username, token);
        this.fatture = await getFatture(username, token);
        this.fatture = this.fatture.filter((fattura) => fattura.flag_pagamento == 0)
        this.rate = await getRataStatusAll(username, token);
        this.rate = this.rate.filter((rata) => rata.status == 'DA VERIFICARE');

        Utils.setAnalyticsPage('Dashboard - ' + cookies.get('db', { path: '/' }));

        this.lezioniInCorso = 0;
        this.lezioni.forEach((lezione) => {
            var currentData = moment().format('yyyy-MM-DD');

            if (currentData === lezione.data.substring(0, 10))
                this.lezioniInCorso++;
        })

        this.lezioni = await Utils.filterLessonsWithoutRegisters(this.lezioni);
        this.lezioni = this.lezioni.sort((l1, l2) => {
            var ll1 = moment(l1.data, "yyyy-MM-DD HH:mm:ss");
            var ll2 = moment(l2.data, "yyyy-MM-DD HH:mm:ss");
            return ll1 - ll2;
        });
        if (this.lezioni.length > 0){  
            this.setState({ warningToShow: true });
        }

        this.setState({ isLoading: false });

    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.handleResize.bind(this));
    }

    render () {

        if (this.state.isLoading) return <NineCellLoading style={{ position: 'absolute', left: '55%', top: '50%' }} />

        return(
            <>
                <PageTitle title="Dashboard" style={{marginLeft: '0.7%'}} />
                <div style={{ display: this.state.isSmallDevice ? 'inherit' : 'flex', width: '100%', marginTop: this.state.isSmallDevice ? 0 : -30, flex: 1 }}>
                    <div style={{...dashboardView, backgroundColor: '#FB89FF', marginLeft: '0.7%', width: this.state.isSmallDevice ? '100%' : '30%' }}>
                        <div style={{ display: 'flex', flex: 1, width: '100%' }}>
                            <img alt="" src={ require('../../images/school_icon.png') } color='#FFFFFF' style={{ position: 'relative', left: '30px', top: '20px', maxHeight: '30px', maxWidth: '30px', flex: 1 }} />
                            <p style={{ color: 'white', fontSize: '1.5rem', flex: 1, marginLeft: 45, marginTop: 20, fontFamily: 'Rubik', }}><b>{t('persone')}</b></p>
                        </div>
                        <p style={{ color: 'white', fontSize: '1rem', flex: 1, marginLeft: 45, marginTop: -10 }}><b>{this.studenti.length}</b> { this.studenti.length === 1 ? t('studente').toLocaleCase() : t('studenti').toLowerCase() } { this.studenti.length === 1 ? t('iscritto') : t('iscritti') }</p>
                        <p style={{ color: 'white', fontSize: '1rem', flex: 1, marginLeft: 45, marginTop: -10 }}><b>{this.insegnanti.length}</b> { this.insegnanti.length === 1 ? t('professore').toLowerCase() : t('insegnanti') } { this.insegnanti.length === 1 ? t('registrato') : t('registrati').toLowerCase() }</p>
                    </div>
                    <div style={{...dashboardView, backgroundColor: '#59A6DF', width: this.state.isSmallDevice ? '100%' : '30%', marginLeft: this.state.isSmallDevice ? '0.7%' : '1.5%', marginTop: this.state.isSmallDevice ? '5px' : '20px' }}>
                        <div style={{ display: 'flex', flex: 1, width: '100%' }}>
                            <img alt="" src={ require('../../images/lessons_icon.png') } color='#FFFFFF' style={{ position: 'relative', left: '30px', top: '20px', maxHeight: '30px', maxWidth: '30px', flex: 1 }} />
                            <p style={{ color: 'white', fontSize: '1.5rem', flex: 1, marginLeft: 45, marginTop: 20, fontFamily: 'Rubik', }}><b>{t('corsi_e_lezioni')}</b></p>
                        </div>
                        <p style={{ color: 'white', fontSize: '1rem', flex: 1, marginLeft: 45, marginTop: -10 }}><b>{this.corsi.length}</b> { this.corsi.length === 1 ? t('corso') : t('corsi').toLowerCase() }</p>
                        <p style={{ color: 'white', fontSize: '1rem', flex: 1, marginLeft: 45, marginTop: -10 }}><b>{this.lezioniInCorso}</b> { this.lezioniInCorso === 1 ? t('lezione').toLowerCase() : t('lezioni').toLowerCase() } {t('oggi')}</p>
                    </div>
                    <div style={{...dashboardView, backgroundColor: '#7DDE77', width: this.state.isSmallDevice ? '100%' : '30%', marginTop: this.state.isSmallDevice ? '5px' : '20px', marginLeft: this.state.isSmallDevice ? '0.7%' : '1.5%' }}>
                        <div style={{ display: 'flex', flex: 1, maxWidth: '100%' }}>
                            <img alt="" src={ require('../../images/billing_icon.png') } color='#FFFFFF' style={{ position: 'relative', left: '30px', top: '20px', maxHeight: '30px', maxWidth: '30px', flex: 1 }} />
                            <p style={{ color: 'white', fontSize: '1.5rem', flex: 1, marginLeft: 45, marginTop: 20, fontFamily: 'Rubik', maxWidth: '80%' }}><b>{t('fatturazione')}</b></p>
                        </div>
                        <p style={{ color: 'white', fontSize: '1rem', flex: 1, marginLeft: 45, marginTop: -10 }}><b>{this.fatture.length}</b> { this.fatture.length === 1 ? t('fattura') : t('fatture') } { this.fatture.length === 1 ? t('non_pagata') : t('non_pagate') }</p>
                        <p style={{ color: 'white', fontSize: '1rem', flex: 1, marginLeft: 45, marginTop: -10 }}><b>{this.rate.length}</b> { this.rate.length === 1 ? t('rata') : t('rate') } {t('da_verificare').toLowerCase()}</p>
                    </div>
                </div>
                <div style={widgetView}>
                    <div style={{ display: 'flex', flex: 1, maxWidth: '100%' }}>
                            <img alt="" src={ require('../../images/alerts_icon.png') } color='#FFFFFF' style={{ position: 'relative', left: '30px', top: '20px', maxHeight: '30px', maxWidth: '30px', flex: 1 }} />
                            <h2 style={widgetTitle}>{t('avvisi')}</h2>
                    </div>
                    <p style={{ marginLeft: '30px', color: '#949494', marginTop: -20}}>{t('lista_avvisi')}</p>
                    <div id='avvisi' style={{ position: 'relative', marginTop: 10, marginBottom: 10, overflowY: 'scroll', overflowX: 'hidden', maxHeight: 300, height: 200, marginBottom: '10px', width: '90%', marginLeft: '30px' }}>
                        { !this.state.warningToShow && (
                            <div style={{ width: '100%', alignSelf: 'center', alignContent: 'center', marginTop: 40, textAlign: 'center' }}>
                                <img src={ require('../../images/no_warnings.png') } alt='No warning' style={{ width: 100, height: 100 }} />
                                <p style={{ fontFamily: 'Courier Prime', fontSize: '1.5em', fontWeight: 'bold', marginTop: 10, color: '#D3D3D3' }}>{t('no_avvisi')}</p>
                            </div>
                        )}
                        { this.state.warningToShow && (
                            this.lezioni.map((lezione) => {
                                return(
                                    <div>
                                        <div key={Math.random()} style={{ width: '100%', marginTop: 20, display: 'flex', flex: 1 }}>
                                            <img src={ require('../../images/warning_sign.png') } alt='Warning' style={{ flex: 1, maxWidth: 20, maxHeight: 20, marginTop: 10, marginRight: 10 }} />
                                            <div style={{flex: 1, marginTop: -2}}>
                                                <p style={{ fontFamily: 'Courier Prime', fontSize: '1rem', fontWeight: 'bold', marginTop: 0, color: '#949494' }}><b>{t('reg_non_compilato')}</b></p>
                                                <p style={{ fontFamily: 'Courier Prime', fontSize: '0.8rem', marginTop: -10, color: '#949494' }}>{t('lezione_del_corso')} {lezione.str_corso} {t('del')} {lezione.data}</p>
                                            </div>
                                        </div>
                                        <div style={{ maxHeight: '1px', height: '1px', width: '90%', marginLeft: 20, backgroundColor: '#E3E3E3' }}></div>
                                    </div>
                                );
                            })
                        )}
                    </div>
                </div>
            </>
        );
    }
}

const dashboardView = {
    width: '30%', 
    minHeight: '80px', 
    marginLeft: '1.5%', 
    marginTop: '20px', 
    borderRadius: '10px', 
    border: '1px solid lightgrey',
    boxShadow: '0px 2px 10px lightgrey',
    flex: 1,
    backgroundImage: `url(${img})`,
    backgroundSize: '100% auto',
    backgroundRepeat: 'no-repeat',
    padddingLeft: '10px', 
    paddingRight: '10px',
    overflow: 'hidden',
};

const widgetTitle = {
    fontWeight: 'bold',
    fontFamily: 'Rubik', 
    fontSize: 30,
    marginBottom: 30,
    marginTop: 15,
    position: 'relative', 
    top: 5, 
    left: 45,
    color: '#A7A7A7',
};

const widgetView = {
    width: '99.3%', 
    marginLeft: '0.7%', 
    backgroundColor: 'white', 
    boxShadow: '0px 2px 10px lightgrey', 
    border: '0px solid lightgrey',
    marginTop: 20,
    flex: 1, 
    borderRadius: '10px',
    overflow: 'hidden', 
    paddingBottom: '10px',
};